export enum LeadWorkflowUpdatedEventChangeFieldEnum {
  WORKFLOW_STATUS = "workflowStatus",
  WORKFLOW_ID = "workflowId",
}
